import React from 'react';

/** A drill-down's head: back to the Overview, its title over "scope · period", and its export. */
const DrilldownHeader = ({ title, subtitle, onBack, onExport, exportDisabled }) => (
  <>
    <button type="button" className="td-btn td-btn--ghost td-drill__back" onClick={onBack}>← Back to overview</button>
    <div className="td-students__head">
      <div>
        <h2 className="td-students__title">{title}</h2>
        {subtitle ? <span className="td-students__caption">{subtitle}</span> : null}
      </div>
      <div className="td-students__controls">
        <button type="button" className="td-btn" disabled={exportDisabled} onClick={onExport}>Export .csv</button>
      </div>
    </div>
  </>
);

export default DrilldownHeader;
